const relationshipWithYourDogProgress: Record<
	RelationshipWithYourDogScreenNames,
	number
> = {
	RYD_INTRO: 0,
	Q18: 0,
	Q19: 25,
	Q20: 50,
	Q21: 75,
	RYD_MULTI_DOG: 100,
};

export const getNextScreenRelationshipWithYourDog = (
	surveyState: NDS.SurveyState,
	formData: NDS.FormData,
	_questionSchema: NDS.QuestionSchema,
): NDS.RouteChange => {
	const screenState = surveyState.routeStack[surveyState.routeStack.length - 1];

	switch (screenState.screen as RelationshipWithYourDogScreenNames) {
		case "RYD_INTRO": {
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				RELATIONSHIP_WITH_YOUR_DOG: relationshipWithYourDogProgress.Q18,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "RELATIONSHIP_WITH_YOUR_DOG",
				screen: "Q18",
			});
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}
		// How do you describe your relationship to your dog?
		case "Q18": {
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				RELATIONSHIP_WITH_YOUR_DOG: relationshipWithYourDogProgress.Q19,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "RELATIONSHIP_WITH_YOUR_DOG",
				screen: "Q19",
			});
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// How much do you agree or disagree with these statements about caring for your [dogNum]?
		case "Q19": {
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				RELATIONSHIP_WITH_YOUR_DOG: relationshipWithYourDogProgress.Q20,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "RELATIONSHIP_WITH_YOUR_DOG",
				screen: "Q20",
			});
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// How much do you agree or disagree with these statements?
		case "Q20": {
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				RELATIONSHIP_WITH_YOUR_DOG: relationshipWithYourDogProgress.Q21,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "RELATIONSHIP_WITH_YOUR_DOG",
				screen: "Q21",
			});
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// What does being a dog owner mean to you, and how does your dog bring joy to your life?
		case "Q21": {
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				RELATIONSHIP_WITH_YOUR_DOG:
					relationshipWithYourDogProgress.RYD_MULTI_DOG,
			};
			if (screenState.dogCount > 1) {
				surveyState.routeStack.push({
					...screenState,
					route: "RELATIONSHIP_WITH_YOUR_DOG",
					screen: "RYD_MULTI_DOG",
				});
				return {
					surveyState,
					formData,
					transition: "RELATIONSHIP_WITH_YOUR_DOG",
				};
			}

			surveyState.routeStack.push({
				...screenState,
				route: "ABOUT_YOU",
				screen: "AY_INTRO_0",
			});
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
				transition: "RELATIONSHIP_WITH_YOUR_DOG",
			};
		}

		case "RYD_MULTI_DOG":
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				RELATIONSHIP_WITH_YOUR_DOG:
					relationshipWithYourDogProgress.RYD_MULTI_DOG,
				ABOUT_YOU: 0,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "ABOUT_YOU",
				screen: "AY_INTRO_0",
			});
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
	}
};
